import React from "react"
import { useLifelongLearningQuery } from "./useLifelongLearningQuery"

export const withLifelongLearningMe = query => WrappedComponent => props => {
  const { data, loading, me, error, refetch } = useLifelongLearningQuery(query)
  return (
    <WrappedComponent
      {...props}
      data={data}
      loading={loading}
      me={me}
      error={error}
      refetch={refetch}
    />
  )
}
